import React from "react";
import SearchArea from "../components/SearchArea";

const SearchAreaScreen = () => {
  return <SearchArea />;
};

export default SearchAreaScreen;
